const GRAIN_TEXTURE =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.35'/%3E%3C/svg%3E\")";

/**
 * Full-bleed atmospheric background for auth pages: slow-drifting orbs in the
 * four logo-dot hues (heavily desaturated), a warm brand wash and fine grain.
 */
export function AuthAmbience() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Soft warm wash, same as the homepage hero */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 30%, var(--color-brand-bg-light), transparent 70%)",
        }}
      />

      {/* Ambient orbs echoing the 4-dot logo mark: blue, gold, petrolej, pink */}
      <div
        className="animate-auth-orb absolute -left-24 -top-32 size-[24rem] rounded-full blur-3xl lg:size-[30rem]"
        style={{ background: "oklch(76% 0.06 235 / 0.2)" }}
      />
      <div
        className="animate-auth-orb absolute -right-28 -top-24 size-[26rem] rounded-full blur-3xl lg:size-[34rem]"
        style={{ background: "oklch(85% 0.085 82 / 0.34)", animationDelay: "-7s" }}
      />
      <div
        className="animate-auth-orb absolute -bottom-40 -left-28 size-[28rem] rounded-full blur-3xl lg:size-[36rem]"
        style={{ background: "oklch(68% 0.07 196 / 0.24)", animationDelay: "-14s" }}
      />
      <div
        className="animate-auth-orb absolute -bottom-28 -right-20 size-[22rem] rounded-full blur-3xl lg:size-[28rem]"
        style={{ background: "oklch(80% 0.07 350 / 0.18)", animationDelay: "-21s" }}
      />

      {/* Fine grain so the gradients never band */}
      <div
        className="absolute inset-0 opacity-50 mix-blend-soft-light"
        style={{ backgroundImage: GRAIN_TEXTURE }}
      />
    </div>
  );
}
